import { LoaderFunction, redirect } from "react-router-dom";
import { axiosApi } from "../../../interceptors/axios";
import { Result } from "../../../types/Result";
import { PassordOptions } from "../passwordValidation";

export const resetPasswordLoader: LoaderFunction = async (args) => {
    const result = await axiosApi.get<Result<PassordOptions>>("/api/auth/password-options");
    const url = new URLSearchParams(new URL(args.request.url).search);
    const token = url.get("token");
    const email = url.get("email");
    if (!token || !email) return redirect("/");
    return { passwordOptions: result.data.data, token, email };
}